<template lang="html">
  <vs-card
    class="cardx card-100-h"
    v-bind:style="{ 'min-height': windowHeight - 155 + 'px' }"
  >
    <div>
      <vs-row>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
          <div v-show="viewType === 'form'">
            <h3>{{ title }}</h3>

            <form @submit.prevent="" class="" data-vv-scope="route">
              <div class="mb-4">
                <label class="vs-input--label">Zone</label>
                <v-select
                  :clearable="false"
                  @input="fetchStations"
                  v-model="item.zone_id"
                  :options="zones"
                  :reduce="(el) => el.id"
                  label="name"
                  name="zone"
                  v-validate="'required'"
                  :class="errors.has('route.zone') ? 'danger' : ''"
                />
                <div
                  v-show="errors.has('route.zone')"
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                  style="height: 19px"
                >
                  <span class="span-text-validation">{{
                    errors.first("route.zone")
                  }}</span>
                </div>
              </div>

              <vs-row class="mb-4">
                <vs-col class="pr-2" vs-lg="4" vs-sm="8" vs-xs="12">
                  <vs-input
                    name="code"
                    v-validate="'required'"
                    :danger="errors.has('route.code')"
                    :danger-text="
                      errors.has('route.code')
                        ? errors.first('route.code')
                        : null
                    "
                    class="inputx"
                    label="Code"
                    placeholder="Code"
                    v-model="item.code"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
                  <vs-input
                    name="name"
                    v-validate="'required'"
                    :danger="errors.has('route.name')"
                    :danger-text="
                      errors.has('route.name')
                        ? errors.first('route.name')
                        : null
                    "
                    class="inputx"
                    label="Name"
                    placeholder="Name"
                    v-model="item.name"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>

              <vs-row class="mb-4">
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    name="start_name"
                    v-validate="'required'"
                    :danger="errors.has('route.start_name')"
                    :danger-text="
                      errors.has('route.start_name')
                        ? errors.first('route.start_name')
                        : null
                    "
                    class="inputx"
                    label="Start"
                    placeholder="Enter start name"
                    v-model="item.start_name"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    name="end_name"
                    v-validate="'required'"
                    :danger="errors.has('route.end_name')"
                    :danger-text="
                      errors.has('route.end_name')
                        ? errors.first('route.end_name')
                        : null
                    "
                    class="inputx"
                    label="End"
                    placeholder="Enter end name"
                    v-model="item.end_name"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>

              <vs-row class="mb-8">
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <div class="mt-5">
                    <vs-checkbox v-model="item.is_active">Enabled</vs-checkbox>
                  </div>
                </vs-col>
              </vs-row>

              <vs-row class="mb-8">
                <vs-col
                  class="pr-2"
                  vs-lg="6"
                  vs-sm="6"
                  vs-xs="12"
                  v-if="
                    this.zones[this.item.zone_index].config
                      .edit_calculated_distance
                  "
                >
                  <vs-input
                    name="kms_calculated"
                    v-validate="''"
                    type="number"
                    :danger="errors.has('route.distance')"
                    :danger-text="
                      errors.has('route.distance')
                        ? errors.first('route.distance')
                        : null
                    "
                    class="inputx"
                    label="KMs calculated"
                    placeholder="0.00"
                    v-model="item.kms_calculated"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col
                  vs-lg="6"
                  vs-sm="6"
                  vs-xs="12"
                  v-if="this.zones[this.item.zone_index].config.edit_price"
                >
                  <vs-input
                    name="price"
                    v-validate="''"
                    type="number"
                    :danger="errors.has('route.price')"
                    :danger-text="
                      errors.has('route.price')
                        ? errors.first('route.price')
                        : null
                    "
                    class="inputx"
                    label="Price"
                    placeholder="0.00"
                    v-model="item.price"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>

              <vs-row
                class="mb-8"
                v-if="
                  this.zones[this.item.zone_index].config.edit_distance_fields
                "
              >
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    name="kms_start"
                    v-validate="''"
                    type="number"
                    :danger="errors.has('route.kms_start')"
                    :danger-text="
                      errors.has('route.kms_start')
                        ? errors.first('route.kms_start')
                        : null
                    "
                    class="inputx"
                    label="KMs start"
                    placeholder="0.00"
                    v-model="item.kms_start"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    name="kms_end"
                    v-validate="''"
                    type="number"
                    :danger="errors.has('route.kms_end')"
                    :danger-text="
                      errors.has('route.kms_end')
                        ? errors.first('route.kms_end')
                        : null
                    "
                    class="inputx"
                    label="KMs end"
                    placeholder="0.00"
                    v-model="item.kms_end"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>

              <vs-row
                class="mb-8"
                v-if="
                  this.zones[this.item.zone_index].config.edit_distance_fields
                "
              >
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    name="kms_in"
                    v-validate="''"
                    type="number"
                    :danger="errors.has('route.kms_in')"
                    :danger-text="
                      errors.has('route.kms_in')
                        ? errors.first('route.kms_in')
                        : null
                    "
                    class="inputx"
                    label="KMs in"
                    placeholder="0.00"
                    v-model="item.kms_in"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    name="kms_out"
                    v-validate="''"
                    type="number"
                    :danger="errors.has('route.kms_out')"
                    :danger-text="
                      errors.has('route.kms_out')
                        ? errors.first('route.kms_out')
                        : null
                    "
                    class="inputx"
                    label="KMs out"
                    placeholder="0.00"
                    v-model="item.kms_out"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>
              <vs-row
                class="mb-8"
                v-if="
                  this.zones[this.item.zone_index].config.edit_distance_fields
                "
              >
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    name="kms_empty_in"
                    v-validate="''"
                    type="number"
                    :danger="errors.has('route.kms_empty_in')"
                    :danger-text="
                      errors.has('route.kms_empty_in')
                        ? errors.first('route.kms_empty_in')
                        : null
                    "
                    class="inputx"
                    label="KMs empty in"
                    placeholder="0.00"
                    v-model="item.kms_empty_in"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    name="kms_empty_out"
                    v-validate="''"
                    type="number"
                    :danger="errors.has('route.kms_empty_out')"
                    :danger-text="
                      errors.has('route.kms_empty_out')
                        ? errors.first('route.kms_empty_out')
                        : null
                    "
                    class="inputx"
                    label="KMs empty out"
                    placeholder="0.00"
                    v-model="item.kms_empty_out"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>
              <vs-row
                class="mb-8"
                v-if="
                  this.zones[this.item.zone_index].config.edit_distance_fields
                "
              >
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <label class="vs-input--label">City/Comunity</label>
                  <v-select
                    :clearable="false"
                    v-model="item.environment_type"
                    :options="['CIUDAD', 'COMUNIDAD', 'CIUDAD-COMUNIDAD']"
                    label="environment type"
                    name="environment_type"
                    :class="
                      errors.has('route.environment_type') ? 'danger' : ''
                    "
                    :danger="errors.has('route.environment_type')"
                    :danger-text="
                      errors.has('route.environment_type')
                        ? errors.first('route.environment_type')
                        : null
                    "
                  />
                </vs-col>
              </vs-row>

              <vs-row
                class="mb-8"
                v-if="
                  this.zones[this.item.zone_index].config.edit_distance_fields
                "
              >
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <label>Shift</label>
                  <v-select
                    @input="editselect"
                    v-model="item.shift_description"
                    :options="this.item.shifts"
                    :items="this.item.shifts"
                    item-text="label"
                    item-value="id"
                    name="shift_description"
                  />
                </vs-col>
              </vs-row>

              <vs-row
                class="mb-8"
                v-if="
                  this.zones[this.item.zone_index].config.edit_distance_fields
                "
              >
                <vs-col class="pr-2" vs-lg="3" vs-sm="3" vs-xs="4">
                  <label class="vs-input--label">Shift start</label>
                  <v-select
                    @input="editselect"
                    :clearable="false"
                    v-model="item.shift_hour_start"
                    :options="[
                      '00',
                      '01',
                      '02',
                      '03',
                      '04',
                      '05',
                      '06',
                      '07',
                      '08',
                      '09',
                      '10',
                      '11',
                      '12',
                      '13',
                      '14',
                      '15',
                      '16',
                      '17',
                      '18',
                      '19',
                      '20',
                      '21',
                      '22',
                      '23',
                    ]"
                    label="Shift hour start"
                    name="shift_hour_start"
                    :class="
                      errors.has('route.shift_hour_start') ? 'danger' : ''
                    "
                  />
                </vs-col>
                <vs-col class="pr-2" vs-lg="3" vs-sm="3" vs-xs="4">
                  <label class="vs-input--label"> </label>
                  <v-select
                    @input="editselect"
                    :clearable="false"
                    v-model="item.shift_minute_start"
                    :options="[
                      '00',
                      '01',
                      '02',
                      '03',
                      '04',
                      '05',
                      '06',
                      '07',
                      '08',
                      '09',
                      '10',
                      '11',
                      '12',
                      '13',
                      '14',
                      '15',
                      '16',
                      '17',
                      '18',
                      '19',
                      '20',
                      '21',
                      '22',
                      '23',
                      '24',
                      '25',
                      '26',
                      '27',
                      '28',
                      '29',
                      '30',
                      '31',
                      '32',
                      '33',
                      '34',
                      '35',
                      '36',
                      '37',
                      '38',
                      '39',
                      '40',
                      '41',
                      '42',
                      '43',
                      '44',
                      '45',
                      '46',
                      '47',
                      '48',
                      '49',
                      '50',
                      '51',
                      '52',
                      '53',
                      '54',
                      '55',
                      '56',
                      '57',
                      '58',
                      '59',
                    ]"
                    label="Shitf minute start"
                    name="shift_minute_start"
                    :class="
                      errors.has('route.shift_minute_start') ? 'danger' : ''
                    "
                  />
                </vs-col>
                <vs-col class="pr-2" vs-lg="3" vs-sm="3" vs-xs="4">
                  <label class="vs-input--label">Shift end</label>
                  <v-select
                    @input="editselect"
                    :clearable="false"
                    v-model="item.shift_hour_end"
                    :options="[
                      '00',
                      '01',
                      '02',
                      '03',
                      '04',
                      '05',
                      '06',
                      '07',
                      '08',
                      '09',
                      '10',
                      '11',
                      '12',
                      '13',
                      '14',
                      '15',
                      '16',
                      '17',
                      '18',
                      '19',
                      '20',
                      '21',
                      '22',
                      '23',
                    ]"
                    label="Shift hour end"
                    name="shift_hour_end"
                    :class="errors.has('route.shift_hour_end') ? 'danger' : ''"
                  />
                </vs-col>
                <vs-col class="pr-2" vs-lg="3" vs-sm="3" vs-xs="4">
                  <label class="vs-input--label"> </label>
                  <v-select
                    @input="editselect"
                    :clearable="false"
                    v-model="item.shift_minute_end"
                    :options="[
                      '00',
                      '01',
                      '02',
                      '03',
                      '04',
                      '05',
                      '06',
                      '07',
                      '08',
                      '09',
                      '10',
                      '11',
                      '12',
                      '13',
                      '14',
                      '15',
                      '16',
                      '17',
                      '18',
                      '19',
                      '20',
                      '21',
                      '22',
                      '23',
                      '24',
                      '25',
                      '26',
                      '27',
                      '28',
                      '29',
                      '30',
                      '31',
                      '32',
                      '33',
                      '34',
                      '35',
                      '36',
                      '37',
                      '38',
                      '39',
                      '40',
                      '41',
                      '42',
                      '43',
                      '44',
                      '45',
                      '46',
                      '47',
                      '48',
                      '49',
                      '50',
                      '51',
                      '52',
                      '53',
                      '54',
                      '55',
                      '56',
                      '57',
                      '58',
                      '59',
                    ]"
                    label="Shitf minute end"
                    name="shift_minute_end"
                    :class="
                      errors.has('route.shift_minute_end') ? 'danger' : ''
                    "
                  />
                </vs-col>
              </vs-row>
            </form>

            <div class="mb-2">
              <vs-button
                class="mr-3"
                :disabled="!item.zone_id || onSubmit"
                color="primary"
                @click="displayStations"
                type="border"
                >Add Station</vs-button
              >
              <vs-button
                class="mr-3"
                :disabled="!item.zone_id || onSubmit"
                color="primary"
                @click="createStation"
                type="border"
                >Create Station</vs-button
              >
            </div>

            <vs-table
              class="mb-2"
              stripe
              :data="item.stations"
              :maxHeight="windowHeight - 190 - 90 - 30 + 'px'"
            >
              <template slot="thead">
                <vs-th style="width: 30px"> </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Type </vs-th>
                <vs-th> </vs-th>
              </template>

              <template slot-scope="{ data }">
                <draggable v-model="item.stations" tag="tbody" handle=".handle">
                  <vs-tr :key="'sr-' + index" v-for="(st, index) in data">
                    <vs-td style="width: 30px">
                      <div class="drag-icon">
                        <feather-icon
                          icon="MoveIcon"
                          svg-classes="icon-sm cursor-pointer handle"
                        />
                      </div>
                    </vs-td>
                    <vs-td>
                      {{ st.name }}
                    </vs-td>
                    <vs-td style="width: 120px">
                      <vs-dropdown class="mr-3" vs-trigger-click>
                        <a
                          class="a-icon"
                          :class="{ 'text-danger': !st.type }"
                          href="#"
                          style="text-transform: uppercase"
                        >
                          {{ st.type ? st.type : "Type" }}
                          <vs-icon class="" icon="expand_more"></vs-icon>
                        </a>
                        <vs-dropdown-menu>
                          <vs-dropdown-item
                            :key="index + '-' + el.value"
                            v-for="el in station_types"
                            @click="
                              st.type = el.value;
                              $set(item.stations, index, st);
                            "
                          >
                            {{ el.text }}
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </vs-td>
                    <vs-td style="width: 30px">
                      <feather-icon
                        @click="item.stations.splice(index, 1)"
                        icon="XIcon"
                        svg-classes="icon-sm cursor-pointer handle "
                      />
                    </vs-td>
                  </vs-tr>
                </draggable>
              </template>
            </vs-table>

            <div
              v-if="false"
              style="
                display: flex;
                flex-direction: column;
                overflow: scroll;
                margin-bottom: 10px;
              "
            >
              <vs-list>
                <draggable v-model="item.stations" handle=".handle">
                  <vs-list-item
                    :key="'list-item-' + index"
                    v-for="(st, index) in item.stations"
                    :title="st.name"
                    :subtitle="st.description"
                  >
                    <template slot="avatar">
                      <feather-icon
                        icon="MoveIcon"
                        svg-classes="icon-sm cursor-pointer handle"
                      />
                    </template>
                    <div style="display: inline-flex">
                      <vs-dropdown class="mr-3">
                        <a class="a-icon" href="#">
                          {{ st.type ? st.type : "Type" }}
                          <vs-icon class="" icon="expand_more"></vs-icon>
                        </a>
                        <vs-dropdown-menu>
                          <vs-dropdown-item
                            :key="el"
                            v-for="el in station_types"
                            @click="st.type = el"
                          >
                            {{ el }}
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                      <feather-icon
                        @click="item.stations.splice(index, 1)"
                        icon="XIcon"
                        svg-classes="icon-sm cursor-pointer handle "
                      />
                    </div>
                  </vs-list-item>
                </draggable>
              </vs-list>
            </div>

            <div class="mb-4">
              <vs-button
                class="mr-3"
                :disabled="
                  !item.zone_id ||
                  item.stations.length < 2 ||
                  onSubmit ||
                  fetchingRoute
                "
                @click="calculateRoute"
                color="success"
                type="border"
              >
                Calculate route
              </vs-button>
              <vs-button
                color="primary"
                :disabled="item.stations.length < 1"
                @click="saveRoute"
                type="filled"
                >Save</vs-button
              >
            </div>
          </div>
          <div v-show="viewType === 'station-form'" :key="'station-form'">
            <form
              @submit.prevent="saveStation"
              class="columns column is-multiline is-12"
              data-vv-scope="station"
            >
              <h3>{{ station_form.id ? "Edit station" : "New station" }}</h3>
              <div class="mb-4">
                <vs-input
                  val-icon-danger="close"
                  class="inputx"
                  :danger="errors.has('station.name')"
                  v-validate="'required'"
                  :danger-text="
                    errors.has('station.name')
                      ? errors.first('station.name')
                      : null
                  "
                  name="name"
                  label="Name"
                  placeholder="Name"
                  v-model="station_form.name"
                  style="width: 100%"
                />
              </div>
              <div class="mb-4">
                <vs-input
                  val-icon-danger="close"
                  class="inputx"
                  :danger="errors.has('station.description')"
                  v-validate="'required|min:5'"
                  :danger-text="
                    errors.has('station.description')
                      ? errors.first('station.description')
                      : null
                  "
                  name="description"
                  label="Description"
                  placeholder="Description"
                  v-model="station_form.description"
                  style="width: 100%"
                />
              </div>

              <div class="mb-4">
                <vs-input
                  val-icon-danger="close"
                  class="inputx"
                  :danger="errors.has('station.address')"
                  v-validate="'required'"
                  :danger-text="
                    errors.has('station.address')
                      ? errors.first('station.address')
                      : null
                  "
                  name="address"
                  label="Address"
                  placeholder="Address"
                  v-model="station_form.address"
                  style="width: 100%"
                />
              </div>

              <vs-row class="mb-4">
                <vs-col class="pr-2" vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    type="number"
                    val-icon-danger="close"
                    class="inputx"
                    :danger="errors.has('station.latitude')"
                    v-validate="'required'"
                    :danger-text="
                      errors.has('station.latitude')
                        ? errors.first('station.latitude')
                        : null
                    "
                    name="latitude"
                    label="Latitude"
                    placeholder="Latitude"
                    v-model="station_form.latitude"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-input
                    type="number"
                    val-icon-danger="close"
                    class="inputx"
                    :danger="errors.has('station.longitude')"
                    v-validate="'required'"
                    :danger-text="
                      errors.has('station.longitude')
                        ? errors.first('station.longitude')
                        : null
                    "
                    name="longitude"
                    label="Longitude"
                    placeholder="Longitude"
                    v-model="station_form.longitude"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>

              <div class="mb-4">
                <label class="vs-input--label">Keywords</label>
                <vs-chips
                  color="rgb(145, 32, 159)"
                  label="Keywords"
                  placeholder="Add keywords"
                  v-model="station_form.keywords"
                >
                  <vs-chip
                    :key="chip"
                    @click="station_form.keywords.splice(idx, 1)"
                    v-for="(chip, idx) in station_form.keywords"
                    closable
                  >
                    {{ chip }}
                  </vs-chip>
                </vs-chips>
              </div>

              <div class="mb-4">
                <ImgInputer
                  placeholder="Drop image here or click"
                  bottom-text="Drop file here or click to change"
                  v-model="image"
                  accept="image/*"
                  theme="light"
                  @onChange="fileChange"
                />
              </div>

              <div class="">
                <vs-button
                  class="mr-3"
                  color="primary"
                  @click="cancelStationForm"
                  type="border"
                  >Cancel</vs-button
                >
                <vs-button
                  class="mr-3"
                  color="primary"
                  @click="saveStation"
                  type="filled"
                  >Save</vs-button
                >
              </div>
            </form>
          </div>
          <div v-show="viewType === 'stations'">
            <vs-table
              class="mb-2"
              stripe
              search
              :data="stations"
              :maxHeight="windowHeight - 190 - 90 - 30 + 'px'"
            >
              <template slot="header">
                <h3>Stations</h3>
              </template>
              <template slot="thead">
                <vs-th> </vs-th>
                <vs-th sort-key="name"> Name </vs-th>
                <vs-th> Action </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="'row-' + indextr" v-for="(st, indextr) in data">
                  <vs-td style="width: 40px">
                    <vs-checkbox
                      v-model="selected"
                      @change="setRouteStations"
                      :vs-value="st.id"
                    ></vs-checkbox>
                  </vs-td>
                  <vs-td :data="st.name">
                    {{ st.name }}
                  </vs-td>

                  <vs-td> </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div class="mb-4">
              <vs-button
                class="mr-3"
                @click="cancelAddStations"
                color="primary"
                type="filled"
                >Cancel</vs-button
              >
              <vs-button color="primary" @click="confirmStations" type="border"
                >Add</vs-button
              >
            </div>
          </div>
        </vs-col>
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div>
            <div
              class="vs-con-input"
              style="width: calc(100% - 10px); margin: 10px"
            >
              <input
                v-model="place"
                :disabled="!item.zone_id"
                id="inputPlace"
                placeholder="Search a place or address"
                type="text"
                class="vs-inputx vs-input--input normal"
                style="border: 1px solid rgba(0, 0, 0, 0.2)"
              />
            </div>
            <LMap
              ref="map"
              :zoom="8"
              :center="[19.41266, -99.141134]"
              style="height: 700px; width: 100%; margin: 10px"
            >
              <!-- Capa de mosaicos (tiles) -->
              <LTileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
              />

              <!-- Marcadores de las estaciones -->
              <LMarker
                v-for="(st, index) in item.stations"
                :key="'marker-' + index"
                :lat-lng="[st.latitude, st.longitude]"
                :icon="dotIcon"
                @click="toggleInfoWindow(st, index)"
              >
                <LPopup>{{ st.name }}</LPopup>
              </LMarker>

              <!-- Ruta en forma de Polyline -->
              <LPolyline :lat-lngs="routePath" :color="'blue'" />
            </LMap>
          </div>
        </vs-col>
      </vs-row>
    </div>
  </vs-card>
</template>

<style scoped>
.card-100-h {
  height: calc(100% - 110px);
}
.mr-3 {
  margin-right: 3rem;
}
.mb-2 {
  margin-bottom: 2rem;
}
.mb-4 {
  margin-bottom: 4rem;
}
.icon-sm {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.vs-list--item {
  background-color: white;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";
import ImgInputer from "vue-img-inputer";
import { STATION_TYPE } from "../../constants/routes";
import { LMap, LTileLayer, LMarker, LPolyline, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
const color = "rgb(115, 103, 240)";
export default {
  name: "EditRoute",
  components: {
    draggable,
    ImgInputer,
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
    LPopup,
  },
  data() {
    return {
      title: "",
      google: null,
      windowHeight: 0,
      map: null,
      polygons: [],
      item: {
        code: null,
        name: null,
        is_active: false,
        stations: [],
        path: [],
      },
      viewType: "form",
      formTitle: "",
      drawingManager: null,
      selectedShape: null,
      stations: [],
      station_icon: null,
      dotIcon: L.icon({
        iconUrl: "/img/dot.png",
        iconSize: [22, 22],
        iconAnchor: [11, 11],
      }),
      dot_icon: null,
      route_stations: [],
      selected: [],
      sMarkers: [],
      directionsDisplay: null,
      directionsService: null,
      station_form: {
        latitude: null,
        longitude: null,
        keywords: [],
        is_active: true,
      },
      autocomplete: null,
      place: null,
      station_types: STATION_TYPE,
      onSubmit: false,
      search: null,
      image: null,

      fetchingRoute: false,

      infoContent: "",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -10,
        },
      },
    };
  },
  computed: {
    ...mapGetters("users", ["userCan"]),
    ...mapGetters("zones", ["zones"]),
    routePath() {
      return this.item.path.map((item) => ({ lat: item[0], lng: item[1] }));
    },
  },
  created() {
    this.initData();
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.fitMapToMarkers();
        });
      },
    },
    windowHeight(newHeight, oldHeight) {
      this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    },
    "$route.params.id": function (id) {
      this.initData();
    },
  },
  mounted() {
    this.changed_shift = false;
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      // window.addEventListener("resize", this.onResize);
      this.fitMapToMarkers();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions("zones", ["fetchZones", "storeZone", "updateZone"]),
    ...mapActions("routes", [
      "getRoute",
      "storeRoute",
      "storeRouteshift",
      "updateRouteshift",
      "getRouteshift",
      "updateRoute",
      "storeStation",
      "getStations",
      "updateRouteStations",
      "routesService",
    ]),
    fitMapToMarkers() {
      // Verificar si hay estaciones con latitud y longitud
      if (this.item.stations.length > 0) {
        const bounds = L.latLngBounds(
          this.item.stations.map((station) => [
            station.latitude,
            station.longitude,
          ])
        );

        // Ajustar el mapa a los límites de los marcadores
        if (this.$refs.map) {
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      }
    },
    initData() {
      this.item.zone_index = 0;

      if (this.$route.params.id) {
        this.title = "Edit route";
        this.getRoute({ id: this.$route.params.id })
          .then((data) => {
            let form = _.cloneDeep(data);
            form.zone_id = form.zone.id;

            if (form.metadata !== null) {
              form.kms_start = form.metadata.kms_start;
              form.kms_end = form.metadata.kms_end;
              form.kms_in = form.metadata.kms_in;
              form.kms_out = form.metadata.kms_out;
              form.kms_empty_in = form.metadata.kms_empty_in;
              form.kms_empty_out = form.metadata.kms_empty_out;
              form.environment_type = form.metadata.environment_type;
              form.price = form.metadata.price;
            }
            form.kms_calculated = form.distance;
            delete form.metadata;
            delete form.zone;
            form.stations = form.stations.map((item) => ({
              ...item.station,
              type: item.type,
              distance: item.distance,
            }));

            this.zones.forEach((item_zone, i) => {
              form.zone_id === item_zone.id ? (this.item.zone_index = i) : null;
            });

            if (this.zones[this.item.zone_index].config.edit_distance_fields) {
              this.getRouteshift({ route_id: form.id })
                .then((data_shift) => {
                  this.item.shifts.forEach((shift, i) => {
                    if (
                      data_shift.description.toString() ===
                      shift.value.toString()
                    ) {
                      form.shift_description = this.item.shifts[i];
                    }
                  });

                  form.shift_hour_start = data_shift.hour_start.substring(0, 2);
                  form.shift_minute_start = data_shift.hour_start.substring(
                    3,
                    5
                  );
                  form.shift_hour_end = data_shift.hour_end.substring(0, 2);
                  form.shift_minute_end = data_shift.hour_end.substring(3, 5);
                })
                .catch((error) => {
                  if (error) {
                    if (error.status === 404) {
                      this.$router.push({ name: "page-error-404" });
                    }
                  }
                });
            }
            this.item = form;

            this.fetchStations();
            this.fitStations();
            //this.item.zone_id = this.item.zone.id;
          })
          .catch((error) => {
            if (error) {
              if (error.status === 404) {
                this.$router.push({ name: "page-error-404" });
              }
            }
          });
      } else {
        this.title = "New route";
        this.viewType = "form";
        this.form = {
          code: null,
          name: null,
          is_active: false,
          stations: [],
          path: [],
        };
      }
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    fetchData() {
      this.fetchZones({ limit: 400 })
        .then((data) => {})
        .catch((error) => {});
    },
    fetchStations() {
      this.item.zone_index = 0;
      this.zones.forEach((item_zone, i) => {
        this.item.zone_id === item_zone.id ? (this.item.zone_index = i) : null;
      });
      this.getStations({ zone_id: this.item.zone_id, limit: 100000 })
        .then((data) => {
          this.stations = _.cloneDeep(data.stations);
        })
        .catch((error) => {});

      this.item.shifts =
        this.zones[this.item.zone_index].config.shift_name_catalog;
    },
    fitStations() {
      if (this.map && this.item.stations.length > 0) {
        let bounds = new google.maps.LatLngBounds();
        for (let item of this.item.stations) {
          bounds.extend({ lat: item.latitude, lng: item.longitude });
        }
        this.map.fitBounds(bounds);
      }
    },
    displayStations() {
      if (!this.item.zone_id) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "Seleccione una zona.",
        });
        return;
      }
      this.viewType = "stations";
      this.selected = this.item.stations.map((item) => item.id);
      this.old_selected = _.cloneDeep(this.selected);
      if (this.item.stations.length > 0) this.setRouteStations();
      else this.route_stations = [];
    },
    cancelAddStations() {
      this.selected = [];
      this.viewType = "form";
    },
    confirmStations() {
      //Add new stations
      this.item.stations = this.item.stations.concat(
        this.stations.filter(
          (item) =>
            this.selected.indexOf(item.id) > -1 &&
            this.old_selected.indexOf(item.id) === -1
        )
      );
      this.cancelAddStations();
    },
    setRouteStations() {
      this.route_stations = this.stations.filter(
        (item) => this.selected.indexOf(item.id) > -1
      );
      this.fitMapStations();
    },
    fitMapStations() {
      let bounds = new google.maps.LatLngBounds();
      for (let item of this.route_stations) {
        bounds.extend({ lat: item.latitude, lng: item.longitude });
      }
      if (this.route_stations.length > 0) this.map.fitBounds(bounds);
    },
    async calculateRoute() {
      if (this.item.stations.length >= 2) {
        let numElements = 20;
        let numRequest = Math.ceil(this.item.stations.length / numElements);
        let cStations = _.cloneDeep(this.item.stations);

        let path = [];
        let distance = 0;
        let stations = [];
        let time = 0;

        this.$vs.loading({
          type: "point",
        });

        for (let i = 0; i < numRequest; i++) {
          let st = cStations.slice(0, numElements);
          let section = _.cloneDeep(st);
          cStations.splice(0, numElements);

          let origin = st.shift();
          let destination = st.pop();
          try {
            let response = await this._getRoute(
              { lat: origin.latitude, lng: origin.longitude },
              { lat: destination.latitude, lng: destination.longitude },
              st
            );

            for (let item of response.routes[0].overview_path) {
              path.push([item.lat(), item.lng()]);
            }

            distance += this.computeTotalDistance(response);

            for (let i = 0; i < response.routes[0].legs.length; i++) {
              time += response.routes[0].legs[i].duration.value;
              if (i === 0) {
                section[i].distance = 0;
              }
              if (section[i + 1]) {
                section[i + 1].distance =
                  response.routes[0].legs[i].distance.value / 1000;
              } else {
                section[i + 1].distance = 0;
              }
            }
            stations = stations.concat(section);
          } catch (e) {
            this.$vs.notify({
              color: "danger",
              title: `Error`,
              text: "Could not display directions",
            });
            break;
          }
        }

        this.item.stations = stations;
        this.item.distance = distance;
        this.item.path = path;
        this.item.time = time;

        this.$vs.loading.close();
      } else {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need at least two stations",
        });
      }
    },
    _calculateRoute() {
      if (this.item.stations.length >= 2) {
        this.fetchingRoute = true;
        this.$vs.loading({
          type: "point",
        });
        this.routesService({
          sort: false,
          waypoints: this.item.stations.map((item) => ({
            lat: item.latitude,
            lng: item.longitude,
          })),
        })
          .then((response) => {
            let route = _.cloneDeep(this.item);
            route.distance = response.response.route[0].summary.distance / 1000;
            route.time = response.response.route[0].summary.baseTime / 60; //minutes

            let path = [
              [route.stations[0].latitude, route.stations[0].longitude],
            ];

            route.stations[0].distance = 0;

            let links = response.response.route[0].leg[0].link;

            for (let el of links) {
              path.push([el.shape[2], el.shape[3]]);
            }
            let lastIndex = 0;
            for (let i = 0; i < route.stations.length; i++) {
              let distance = 0;
              if (i > 0) {
                let linkId = response.response.route[0].waypoint[
                  i
                ].linkId.replace("+", "");
                for (let j = lastIndex; j < links.length; j++) {
                  if (links[j].linkId === linkId) {
                    lastIndex = j + 1;
                    break;
                  }
                  distance += links[j].length;
                }
              }
              route.stations[i].distance = distance / 1000;
            }

            route.path = path;
            this.item = _.cloneDeep(route);
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: `Error`,
              text: "Could not display directions due to: ",
            });
          })
          .finally(() => {
            this.fetchingRoute = false;
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "Se necesita al menos 2 estaciones",
        });
      }
    },
    _getRoute(origin, destination, waypoints) {
      let wpts = waypoints.map((item) => ({
        location: { lat: item.latitude, lng: item.longitude },
      }));
      return new Promise((resolve, reject) => {
        this.directionsService.route(
          {
            origin: origin,
            destination: destination,
            waypoints: wpts,
            travelMode: "DRIVING",
            avoidTolls: true,
          },
          (response, status) => {
            if (status === "OK") {
              resolve(response);
            } else {
              reject(response);
            }
          }
        );
      });
    },
    displayRoute(origin, destination, waypoints) {
      let wpts = waypoints.map((item) => ({
        location: { lat: item.latitude, lng: item.longitude },
      }));
      this.directionsService.route(
        {
          origin: origin,
          destination: destination,
          waypoints: wpts,
          travelMode: "DRIVING",
          avoidTolls: true,
        },
        (response, status) => {
          if (status === "OK") {
            //this.directionsDisplay.setDirections(response);
            this.item.path = response.routes[0].overview_path.map((item) => [
              item.lat(),
              item.lng(),
            ]);
            this.item.distance = this.computeTotalDistance(response);
            let time = 0;
            for (let i = 0; i < response.routes[0].legs.length; i++) {
              time += response.routes[0].legs[i].duration.value;
              if (i === 0) {
                this.item.stations[i].distance = 0;
              }
              this.item.stations[i + 1].distance =
                response.routes[0].legs[i].distance.value / 1000;
            }
            this.item.time = time;
          } else {
            this.$vs.notify({
              color: "danger",
              title: `Error`,
              text: "Could not display directions due to: " + status,
            });
          }
        }
      );
    },
    editselect() {
      let form = _.cloneDeep(this.item);
      this.changed_shift = true;
      this.item = form;
    },
    computeTotalDistance(result) {
      let total = 0;
      let myroute = result.routes[0];
      for (let i = 0; i < myroute.legs.length; i++) {
        total += myroute.legs[i].distance.value;
      }
      total = total / 1000; //km
      return total;
    },
    async saveRoute(data) {
      let errorTypeStation = false;
      for (let i = 0; i < this.item.stations.length; i++) {
        this.item.stations[i].order = i + 1;
        if (!this.item.stations[i].type) {
          errorTypeStation = true;
        }
      }
      if (errorTypeStation) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You have to set station type",
        });
        return;
      }

      if (this.onSubmit === true) {
        return;
      }

      this.$validator.validateAll("route").then((result) => {
        if (result) {
          let form = _.cloneDeep(this.item);
          form.stations = form.stations.map((item) => ({
            id: item.id,
            order: item.order,
            type: item.type,
            distance: item.distance || 0,
          }));
          if (this.zones[this.item.zone_index].config.edit_distance_fields) {
            var obj = {
              kms_start: this.item.kms_start,
              kms_end: this.item.kms_end,
              kms_in: this.item.kms_in,
              kms_out: this.item.kms_out,
              kms_empty_in: this.item.kms_empty_in,
              environment_type: this.item.environment_type,
              kms_empty_out: this.item.kms_empty_out,
            };
            form.metadata = obj;
            delete form.kms_start;
            delete form.kms_end;
            delete form.kms_in;
            delete form.kms_out;
            delete form.kms_empty_in;
            delete form.environment_type;
            delete form.kms_empty_out;
          }
          if (this.zones[this.item.zone_index].config.edit_price) {
            var obj = { price: this.item.price };
            form.metadata
              ? (form.metadata.price = this.item.price)
              : (form.metadata = obj);
            delete form.price;
          }
          if (this.zones[this.item.zone_index].config.edit_distance_fields) {
            form.distance = this.item.kms_calculated;
          }
          delete form.kms_calculated;
          delete form.zone_index;

          if (form.id) {
            if (!this.userCan("routes.update")) {
              this.$vs.notify({
                color: "danger",
                title: `Error`,
                text: "You need permission to perform this action",
              });
              return;
            }

            this.onSubmit = true;

            this.$vs.loading({
              type: "point",
            });
            let payload_routeshift = null;
            if (
              this.zones[this.item.zone_index].config.edit_calculated_distance
            ) {
              form.metadata.environment_type =
                form.metadata.environment_type.toUpperCase();

              let form_shift_hour_start = form.shift_hour_start;
              let form_shift_minute_start = form.shift_minute_start;
              let form_shift_hour_end = form.shift_hour_end;
              let form_shift_minute_end = form.shift_minute_end;
              let form_shift_description =
                form.shift_description.value.toString();

              payload_routeshift = {
                route_id: this.item.id,
                description: form_shift_description,
                hour_start:
                  form_shift_hour_start + ":" + form_shift_minute_start + ":00",
                hour_end:
                  form_shift_hour_end + ":" + form_shift_minute_end + ":00",
              };
            }
            delete form.shift_hour_start;
            delete form.shift_minute_start;
            delete form.shift_hour_end;
            delete form.shift_minute_end;
            delete form.shift_description;
            delete form.shifts;

            this.updateRoute(form)
              .then((data) => {
                if (
                  this.zones[this.item.zone_index].config
                    .edit_calculated_distance
                ) {
                  if (this.changed_shift) {
                    this.updateRouteshift(payload_routeshift)
                      .then((data_rs) => {
                        this.$vs.loading.close();
                        this.onSubmit = false;
                        this.$router.push({ name: "routes List" });
                      })
                      .catch((error) => {
                        this.$vs.loading.close();
                        this.onSubmit = false;
                        if (error) {
                          if (error.status === 409 || error.status === 400) {
                            if (error.data.detail === "Invalid params") {
                              this.$vs.notify({
                                color: "danger",
                                title: `Error`,
                                text: "There are invalid or missng params. Please fix and try again.",
                              });
                            }
                            this.setErrors("route", error.data.errors);
                          } else {
                            this.$vs.notify({
                              color: "danger",
                              title: `Error`,
                              text: "There was an error. Please try again later.",
                            });
                          }
                        }
                      });
                  } else {
                    this.$vs.loading.close();
                    this.onSubmit = false;
                    this.$router.push({ name: "routes List" });
                  }
                } else {
                  this.$vs.loading.close();
                  this.onSubmit = false;
                  this.$router.push({ name: "routes List" });
                }
              })
              .catch((error) => {
                this.$vs.loading.close();
                this.onSubmit = false;
                if (error) {
                  if (error.status === 409 || error.status === 400) {
                    this.setErrors("route", error.data.errors);
                  } else {
                    this.$vs.notify({
                      color: "danger",
                      title: `Error`,
                      text: "There was an error. Please try again later.",
                    });
                  }
                }
              });
          } else {
            if (!this.userCan("routes.create")) {
              this.$vs.notify({
                color: "danger",
                title: `Error`,
                text: "You need permission to perform this action",
              });
              return;
            }
            this.onSubmit = true;

            this.$vs.loading({
              type: "point",
            });
            let payload_routeshift;
            if (this.zones[this.item.zone_index].config.edit_distance_fields) {
              let form_shift_hour_start = form.shift_hour_start;
              let form_shift_minute_start = form.shift_minute_start;
              let form_shift_hour_end = form.shift_hour_end;
              let form_shift_minute_end = form.shift_minute_end;
              let form_shift_description =
                form.shift_description.value.toString();
              delete form.shift_hour_start;
              delete form.shift_minute_start;
              delete form.shift_hour_end;
              delete form.shift_minute_end;
              delete form.shift_description;
              delete form.shifts;
              payload_routeshift = {
                route_id: 0,
                description: form_shift_description,
                hour_start:
                  form_shift_hour_start + ":" + form_shift_minute_start + ":00",
                hour_end:
                  form_shift_hour_end + ":" + form_shift_minute_end + ":00",
              };
            }
            this.storeRoute(form)
              .then((data) => {
                if (
                  this.zones[this.item.zone_index].config
                    .edit_calculated_distance
                ) {
                  payload_routeshift.route_id = data.id;
                  this.storeRouteshift(payload_routeshift)
                    .then((data_rs) => {
                      this.$vs.loading.close();
                      this.onSubmit = false;
                      this.$router.push({ name: "routes List" });
                    })
                    .catch((error) => {
                      this.$vs.loading.close();
                      this.onSubmit = false;
                      if (error) {
                        if (error.status === 409 || error.status === 400) {
                          if (error.data.detail === "Invalid params") {
                            this.$vs.notify({
                              color: "danger",
                              title: `Error`,
                              text: "There are invalid or missng params. Please fix and try again.",
                            });
                          }
                          this.setErrors("route", error.data.errors);
                        } else {
                          this.$vs.notify({
                            color: "danger",
                            title: `Error`,
                            text: "There was an error. Please try again later.",
                          });
                        }
                      }
                    });
                } else {
                  this.$vs.loading.close();
                  this.onSubmit = false;
                  this.$router.push({ name: "routes List" });
                }
              })
              .catch((error) => {
                this.$vs.loading.close();
                this.onSubmit = false;
                if (error) {
                  if (error.status === 409 || error.status === 400) {
                    if (error.data.errors.metadata) {
                      error.data.errors.metadata.environment_type
                        ? (error.data.errors.environment_type =
                            error.data.errors.metadata.environment_type)
                        : null;
                      error.data.errors.metadata.kms_empty_in
                        ? (error.data.errors.kms_empty_in =
                            error.data.errors.metadata.kms_empty_in)
                        : null;
                      error.data.errors.metadata.kms_empty_out
                        ? (error.data.errors.kms_empty_out =
                            error.data.errors.metadata.kms_empty_out)
                        : null;
                      error.data.errors.metadata.kms_end
                        ? (error.data.errors.kms_end =
                            error.data.errors.metadata.kms_end)
                        : null;
                      error.data.errors.metadata.kms_in
                        ? (error.data.errors.kms_in =
                            error.data.errors.metadata.kms_in)
                        : null;
                      error.data.errors.metadata.kms_out
                        ? (error.data.errors.kms_out =
                            error.data.errors.metadata.kms_out)
                        : null;
                      error.data.errors.metadata.kms_start
                        ? (error.data.errors.kms_start =
                            error.data.errors.metadata.kms_start)
                        : null;
                      error.data.errors.metadata.price
                        ? (error.data.errors.price =
                            error.data.errors.metadata.price)
                        : null;
                    }
                    this.setErrors("route", error.data.errors);

                    if (error.data.detail === "Invalid params") {
                      this.$vs.notify({
                        color: "danger",
                        title: `Error`,
                        text: "There are invalid or missng params. Please fix and try again.",
                      });
                    }
                  } else {
                    this.$vs.notify({
                      color: "danger",
                      title: `Error`,
                      text: "There was an error. Please try again later.",
                    });
                  }
                }
              });
          }
        }
      });
    },
    createStation() {
      this.drawingManager.setDrawingMode("marker");
      this.viewType = "station-form";
      this.station_form = {
        name: null,
        latitude: null,
        longitude: null,
        keywords: [],
        is_active: true,
      };
    },
    cancelStationForm() {
      this.viewType = "form";
      this.station_form = {
        name: null,
        latitude: null,
        longitude: null,
        keywords: [],
        is_active: true,
      };
      this.place = null;
      this.image = null;
    },
    saveStation() {
      this.$validator.validateAll("station").then((result) => {
        if (result) {
          this.$vs.loading({
            type: "point",
          });
          this.station_form.zone_id = this.item.zone_id;
          this.storeStation(this.station_form)
            .then((data) => {
              this.$vs.loading.close();
              this.item.stations.push(data);
              this.cancelStationForm();
            })
            .catch((error) => {
              this.$vs.loading.close();
              if (error) {
                if (error.status === 409 || error.status === 400) {
                  this.setErrors("station", error.data.errors);
                } else {
                  this.$vs.notify({
                    color: "danger",
                    title: `Error`,
                    text: "There was an error. Please try again later.",
                  });
                }
              }
            });
        }
      });
    },
    setErrors(scope, errors) {
      for (let key in errors) {
        if (Array.isArray(errors[key])) {
          this.errors.add({
            field: key,
            msg: errors[key][0],
            scope: scope,
          });
        }
      }
    },
    onPlaceChanged() {
      this.viewType = "station-form";
      let place = this.autocomplete.getPlace();
      this.station_form.latitude = place.geometry.location.lat();
      this.station_form.longitude = place.geometry.location.lng();
      this.station_form.name = place.name;
      this.station_form.address = place.formatted_address;
      if (place.geometry) {
        this.map.panTo(place.geometry.location);
        this.map.setZoom(15);
      }
    },
    onDragend(coordinate) {
      this.station_form.latitude = coordinate.latLng.lat();
      this.station_form.longitude = coordinate.latLng.lng();
    },
    fileChange(file, filename) {
      let reader = new FileReader();
      reader.readAsDataURL(this.image);
      reader.onload = () => {
        this.station_form.image = reader.result.split(",").pop();
      };
    },

    toggleInfoWindow: function (station, idx) {
      this.infoWindowPos = { lat: station.latitude, lng: station.longitude };
      this.infoContent = `${idx + 1}: ${station.name}`;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
  },
};
</script>
